export default "__VITE_PUBLIC_ASSET__656086cc__"